import Prism from 'prismjs';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-elixir';
import 'prismjs/components/prism-go';
import 'prismjs/components/prism-hcl';
import 'prismjs/components/prism-ruby';
import 'prismjs/components/prism-rust';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-markup-templating';
import 'prismjs/components/prism-php';
import 'prismjs/components/prism-csharp';
import 'prismjs/components/prism-rust';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-python';

export default {
  curl: {
    language: 'bash',
    label: 'Curl',
    grammar: Prism.languages.bash,
    browser: true,
    examples: [
      { label: 'Domains', url: '/api-examples/curl/domains.sh' },
      { label: 'DNS', url: '/api-examples/curl/dns.sh' },
      { label: 'Certificates', url: '/api-examples/curl/certificates.sh' }
    ]
  },

  elixir: {
    language: 'elixir',
    label: 'Elixir',
    grammar: Prism.languages.elixir,
    browser: true,
    examples: [
      { label: 'Domains', url: '/api-examples/elixir/domains.ex' },
      { label: 'DNS', url: '/api-examples/elixir/dns.ex' },
      { label: 'Certificates', url: '/api-examples/elixir/certificates.ex' }
    ]
  },
  go: {
    grammar: Prism.languages.go,
    language: 'go',
    label: 'GO',
    browser: true,
    examples: [
      { label: 'Domains', url: '/api-examples/go/domains.go' },
      { label: 'DNS', url: '/api-examples/go/dns.go' },
      { label: 'SSL Certificates', url: '/api-examples/go/certificates.go' }
    ]
  },
  node: {
    grammar: Prism.languages.javascript,
    language: 'javascript',
    label: 'Node.js',
    browser: true,
    examples: [
      { label: 'Domains', url: '/api-examples/node/domains.js' },
      { label: 'DNS', url: '/api-examples/node/dns.js' },
      { label: 'Certificates', url: '/api-examples/node/certificates.js' }
    ]
  },
  ruby: {
    grammar: Prism.languages.ruby,
    language: 'ruby',
    label: 'Ruby',
    browser: true,
    examples: [
      { label: 'Domains', url: '/api-examples/ruby/domains.rb' },
      { label: 'DNS', url: '/api-examples/ruby/dns.rb' },
      { label: 'Certificates', url: '/api-examples/ruby/certificates.rb' }
    ]
  },
  php: {
    grammar: Prism.languages.php,
    language: 'php',
    label: 'PHP',
    browser: true,
    examples: [
      { label: 'Domains', url: '/api-examples/php/domains.php' },
      { label: 'DNS', url: '/api-examples/php/dns.php' }
    ]
  },
  dotnet: {
    grammar: Prism.languages.csharp,
    language: 'csharp',
    label: '.NET',
    browser: true,
    examples: [
      { label: 'Domains', url: '/api-examples/csharp/domains.cs' },
      { label: 'DNS', url: '/api-examples/csharp/dns.cs' },
      { label: 'SSL Certificates', url: '/api-examples/csharp/certificates.cs' }
    ]
  },
  rust: {
    grammar: Prism.languages.rust,
    language: 'rust',
    label: 'Rust',
    browser: true,
    examples: [
      { label: 'Domains', url: '/api-examples/rust/domains.rs' },
      { label: 'DNS', url: '/api-examples/rust/dns.rs' },
      { label: 'SSL Certificates', url: '/api-examples/rust/certificates.rs' }
    ]
  },
  java: {
    grammar: Prism.languages.java,
    language: 'java',
    label: 'Java',
    browser: true,
    examples: [
      { label: 'Domains', url: '/api-examples/java/domains.java' },
      { label: 'DNS', url: '/api-examples/java/dns.java' },
      { label: 'SSL Certificates', url: '/api-examples/java/certificates.java' }
    ]
  },
  python: {
    language: 'python',
    grammar: Prism.languages.python,
    label: 'Python',
    browser: true,
    examples: [
      { label: 'Domains', url: '/api-examples/python/domains.py' },
      { label: 'DNS', url: '/api-examples/python/dns.py' },
      { label: 'SSL Certificates', url: '/api-examples/python/certificates.py' }
    ]
  },
  terraform: {
    grammar: Prism.languages.hcl,
    language: 'hcl',
    browser: false,
    label: 'Terraform',
    examples: [
      { label: 'Domains Registration', url: '/api-examples/terraform/registration.tf' },
      { label: 'Domain Delegation', url: '/api-examples/terraform/delegation.tf' },
      { label: 'DNS', url: '/api-examples/terraform/dns.tf' },
      { label: 'SSL Certificates', url: '/api-examples/terraform/certificates.tf' },
      { label: 'Email Forwards', url: '/api-examples/terraform/email.tf' }
    ]
  }
};
